import { Box, Typography, Divider } from "@mui/material";
import * as styles from "../styles/styles";
import FilterTabs from "./FilterTabs";
import SingleOrderCard from "./SingleOrderCard";
import { JobModalsManager, useJobModalsManager } from "../../JobModalsManager";

const onGoingOrders = [
  {
    id: 1,
    name: "Best Cleaning",
    orderId: "567",
    dueDate: "12/04/25",
    status: "in-progress",
    orderImage: "vu.png",
    orderCategory: "services",
  },

  {
    id: 2,
    name: "Best Cleaning",
    orderId: "567",
    deliveryDate: "12/04/25",
    status: "in-progress",
    orderImage: "vu.png",
    orderCategory: "products",
  },

  {
    id: 3,
    name: "Best Cleaning",
    orderId: "567",
    deliveryDate: "12/04/25",
    deliveryTime: "18:35",
    status: "pending",
    orderImage: "vu.png",
    orderCategory: "restaurants",
  },

  {
    id: 4,
    name: "Best Cleaning",
    orderId: "567",
    expiryDate: "12/04/25",
    status: "pending",
    orderImage: "vu.png",
    orderCategory: "coupons",
  },
];

const ordersHistoryData = [
  {
    id: 1,
    name: "Best Cleaning",
    orderId: "567",
    paymentDate: "12/04/25",
    status: "completed",
    orderImage: "vu.png",
    orderCategory: "services",
  },

  {
    id: 2,
    name: "Best Cleaning",
    orderId: "567",
    paymentDate: "12/04/25",
    status: "cancelled",
    orderImage: "vu.png",
    orderCategory: "products",
  },

  {
    id: 3,
    name: "Best Cleaning",
    orderId: "567",
    paymentDate: "12/04/25",
    status: "completed",
    orderImage: "vu.png",
    orderCategory: "restaurants",
  },

  {
    id: 4,
    name: "Best Cleaning",
    orderId: "567",
    paymentDate: "12/04/25",
    status: "completed",
    orderImage: "vu.png",
    orderCategory: "coupons",
  },
];

const MyOrders = (props) => {
  const { selectedOrderTabs, setSelectedOrderTabs } = props;
  const { openJobModal, modalState, modalHandlers } = useJobModalsManager();

  const {
    contentContainerWrapper,
    contentContainer,
    ordersWrapper,
    ordersTitle,
  } = styles;

  const handleViewJob = (job, type) => {
    openJobModal(job, type);
  };

  return (
    <Box sx={contentContainerWrapper}>
      <Box
        sx={{
          ...contentContainer,
          py: "32px",
          px: "0px",
          background: "rgba(248, 247, 250, 1)",
        }}
      >
        <Box sx={ordersWrapper}>
          <Typography sx={ordersTitle}>Ongoing Orders</Typography>

          <FilterTabs {...{ selectedOrderTabs, setSelectedOrderTabs }} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {onGoingOrders.map((order, index) => (
              <SingleOrderCard
                key={index}
                order={order}
                onGoingOrders={true}
                handleViewJob={handleViewJob}
              />
            ))}
          </Box>
        </Box>

        <Divider sx={{ my: "24px", borderColor: "rgba(234, 234, 234, 1)" }} />

        <Box sx={ordersWrapper}>
          <Typography sx={ordersTitle}>Order History</Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {ordersHistoryData.map((order, index) => (
              <SingleOrderCard
                key={index}
                order={order}
                onGoingOrders={false}
                handleViewJob={handleViewJob}
              />
            ))}
          </Box>
        </Box>
      </Box>

      <JobModalsManager modalState={modalState} modalHandlers={modalHandlers} />
    </Box>
  );
};

export default MyOrders;
